var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRili3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_rili3_svg__clip0_5124_53574)",
    stroke: "#3F465C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.958 6.182H13.5m0 .818V3.5A.5.5 0 0013 3H3a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h5.5M5.5 1.5V4M10.5 1.5V4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.581a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.519 10.2v1h1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_rili3_svg__clip0_5124_53574"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_rili3.c3f27637.svg";
export { SvgTongyongRili3 as ReactComponent };